import React from "react";
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { Spinner } from 'react-bootstrap';

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        // debugger;
        return (
            <div className="custom-tooltip">
                <div>{payload[0].payload.carrierName} ({label})</div>
                <div className="tooltipTitle_yellow">EDI : {payload[0].value} % </div>
                <div className="tooltipTitle_blue">Manual Data Entry : {payload[1].value} %</div>
                <div className="tooltipTitle_lightblue">OCR Data Entry : {payload[2].value} %</div>
            </div>
        );
    }

    return null;
};

const CustomSpinner = () => {
    return (
        <>
            <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
                <div className="card mb-2">
                    <MySpinner />
                    <div className="card-header blue-heading">
                        Top Transportation Providers by Bill Type
                    </div>
                    <div className="card-body search-form">
                        <div style={{ width: '100%' }} className='set-height'>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const MySpinner = () => {
    return (
        <Spinner className='spinner-border spinner-border-chart' />
    )
}

const RenderChart = ({ data }) => {
    let distinctCarriers = [];
    let rows = [];
    if (data.length > 0) {
        // debugger;
        const isCarrierExists = (carrierkey) => {

            return distinctCarriers.filter(row => row._carrierKey === carrierkey)
        }


        const getTotalBillsByCarrier = (carrierKey) => {
            let totBill = 0;
            let totalCarrBills = data.filter(row => row.carrierKey === carrierKey);

            totalCarrBills.map((currRow) => {
                totBill += currRow.totalBills;
            })

            return totBill;
        }

        const getTotalBillsByCarrierBillType = (_carrierKey, _billType) => {
            // debugger;
            let totBill = 0;
            let totalCarrBills = data.filter(row => row.carrierKey === _carrierKey && row.billType === _billType);

            totalCarrBills.map((currRow) => {
                totBill += currRow.totalBills;
            })

            return totBill;
        }


        // Dib 18-11-2022

        // 1. get distinct carrier and store in array

        // const carrierRows = new Map();
        data.map((carrier_row) => {
            // debugger;
            let existingRow = isCarrierExists(carrier_row.carrierKey)
            if (existingRow.length === 0) {

                distinctCarriers.push({
                    _carrierKey: carrier_row.carrierKey
                });

                let totalCarrierBills = getTotalBillsByCarrier(carrier_row.carrierKey);

                // 3. filter the carrier data based on Type
                let OCR_Per = 0;
                let EDI_Per = 0;
                let PAP_Per = 0;

                let tot_edi_Bills = 0;
                let tot_ocr_Bills = 0;
                let tot_pap_Bills = 0;


                tot_edi_Bills = getTotalBillsByCarrierBillType(carrier_row.carrierKey, "EDI");
                // EDI_Per = parseInt(tot_edi_Bills);
                EDI_Per = Math.round((parseInt(tot_edi_Bills) / parseInt(totalCarrierBills)) * 100);


                tot_ocr_Bills = getTotalBillsByCarrierBillType(carrier_row.carrierKey, "OCR Data Entry");

                // OCR_Per = parseInt(tot_ocr_Bills);
                OCR_Per = Math.round((parseInt(tot_ocr_Bills) / parseInt(totalCarrierBills)) * 100);




                tot_pap_Bills = getTotalBillsByCarrierBillType(carrier_row.carrierKey, "Manual Data Entry");
                // PAP_Per = parseInt(tot_pap_Bills);
                PAP_Per = Math.round((parseInt(tot_pap_Bills) / parseInt(totalCarrierBills)) * 100);



                let newRow = [];

                newRow = {
                    "carrierSCACCode": carrier_row.carrierSCACCode,
                    "carrierName": carrier_row.carrierName,
                    "OCR": OCR_Per,
                    "EDI": EDI_Per,
                    "PAP": PAP_Per
                }
                rows = [...rows, newRow]

                // distinctCarriers.push({
                //     _carrierKey: item.carrierKey,
                //     _carrierSCACCode: item.carrierSCACCode,
                //     _carrierName: item.carrierName,
                //     _billType: item.billType
                // });
            }
        })

        // 2. Loop the distinct carriers
        // debugger;
        // distinctCarriers.map((carrierrow) => {
        //     debugger;
        //     let totalCarrierBills = getTotalBillsByCarrier(carrierrow._carrierKey);

        //     // 3. filter the carrier data based on Type
        //     let OCR_Per = 0;
        //     let EDI_Per = 0;
        //     let PAP_Per = 0;

        //     let tot_edi_Bills = 0;
        //     let tot_ocr_Bills = 0;
        //     let tot_pap_Bills = 0;

        //     if (carrierrow.billType === "EDI") {
        //         tot_edi_Bills = data.filter(row => row.carrierKey === carrierrow._carrierKey && carrierrow._billType === "EDI")
        //         if (tot_edi_Bills.length > 0) {
        //             EDI_Per = (parseInt(tot_edi_Bills) / parseInt(totalCarrierBills)) * 100;
        //         }
        //     }
        //     else if (carrierrow.billType === "OCR Data Entry") {
        //         tot_ocr_Bills = data.filter(row => row.carrierKey === carrierrow._carrierKey && carrierrow._billType === "OCR Data Entry")
        //         if (tot_ocr_Bills.length > 0) {
        //             OCR_Per = (parseInt(tot_ocr_Bills) / parseInt(totalCarrierBills)) * 100;
        //         }
        //     }
        //     else {

        //         tot_pap_Bills = data.filter(row => row.carrierKey === carrierrow._carrierKey && carrierrow._billType === "Manual Data Entry")
        //         if (tot_pap_Bills.length > 0) {
        //             PAP_Per = (parseInt(tot_pap_Bills) / parseInt(totalCarrierBills)) * 100;
        //         }
        //     }

        //     // let newRow = [];

        //     let newRow = {
        //         "carrierSCACCode": carrierrow._carrierSCACCode,
        //         "carrierName": carrierrow._carrierName,
        //         "OCR": OCR_Per,
        //         "EDI": EDI_Per,
        //         "PAP": PAP_Per
        //     }
        //     rows = [...rows, newRow]

        // })


        // Dib 18-11-2022

        // data.map((row) => {
        //     // debugger;
        //     let totalCarrierBills = getTotalBillsByCarrier(row.carrierKey);
        //     console.log(totalCarrierBills);

        //     let OCR = 0;
        //     let EDI = 0;
        //     let PAP = 0;

        //     const scacCode = row.carrierSCACCode;
        //     const carrierName = row.carrierName;

        //     if (row.billType === "EDI") {
        //         EDI = parseInt(row.totalBills);
        //     }
        //     else if (row.billType === "OCR Data Entry") {
        //         OCR = parseInt(row.totalBills);
        //     }
        //     else {
        //         PAP = parseInt(row.totalBills);
        //     }

        //     let newRow = [];
        //     let existingRow = isCarrierExists(scacCode);

        //     if (existingRow.length === 0) {
        //         newRow = {
        //             "carrierSCACCode": scacCode,
        //             "carrierName": carrierName,
        //             "OCR": OCR,
        //             "EDI": EDI,
        //             "PAP": PAP
        //         }
        //         rows = [...rows, newRow]
        //     }
        //     else {
        //         if (EDI > 0) {
        //             existingRow[0].EDI = EDI;
        //         }
        //         else if (OCR > 0) {
        //             existingRow[0].OCR = OCR;
        //         }
        //         else {
        //             existingRow[0].PAP = PAP;
        //         }
        //         const existingRows = rows.filter((r) => r.carrierSCACCode !== scacCode)
        //         rows = [...existingRows, existingRow[0]]
        //     }
        // })
    }

    return (
        <>
            <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
                <div className="card mb-2">
                    <div className="card-header blue-heading">
                        Top Transportation Providers by Bill Type
                    </div>
                    <div className="card-body search-form">
                        <div style={{ width: '100%' }} className='set-height'>
                            <ResponsiveContainer>
                                <BarChart data={rows}
                                    margin={{
                                        top: 10,
                                        right: 30,
                                        left: 0,
                                        bottom: 0,
                                    }}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="carrierSCACCode" />
                                    <YAxis />
                                    <Tooltip content={<CustomTooltip />} />
                                    <Legend />
                                    <Bar dataKey="EDI" stackId="a" fill="#eac205" />
                                    <Bar dataKey="PAP" name="Manual Data Entry" stackId="a" fill="#1f79a4" />
                                    <Bar dataKey="OCR" name="OCR Data Entry" stackId="a" fill="#33CC99" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default function TopProviderByBillType({ data, loading }) {
    if (loading) {
        return <CustomSpinner />
    }

    return <RenderChart data={data} />
}